// assets/lpo.js – schlanke Version, Recalc nach Cart-Änderung

(function() {
  var DEBUG = false; // bei Bedarf auf true stellen

  function log() {
    if (DEBUG && typeof console !== 'undefined' && console.debug) {
      console.debug.apply(console, arguments);
    }
  }

  var FORMAT_OPTION_NAME = 'Format'; // so heißt die LPO-Option in data-option

  function getFormatOptionElement() {
    var el = document.querySelector('.cl-po--option[data-option="' + FORMAT_OPTION_NAME + '"]');
    if (!el) {
      log('[LPO-RECALC] Kein Format-Option-Element gefunden.');
    }
    return el;
  }

  function getFormatInputs() {
    var optionEl = getFormatOptionElement();
    if (!optionEl) return { x: null, y: null };

    var xInput = optionEl.querySelector('input[name="properties[_Format_x]"]');
    var yInput = optionEl.querySelector('input[name="properties[_Format_y]"]');

    if (!xInput || !yInput) {
      log('[LPO-RECALC] Format-Inputs nicht gefunden:', xInput, yInput);
    } else {
      log('[LPO-RECALC] Format-Inputs gefunden:', xInput, yInput);
    }

    return { x: xInput, y: yInput };
  }

  function triggerLpoRecalcFromFormat() {
    var inputs = getFormatInputs();
    if (!inputs.x || !inputs.y) return;

    [inputs.x, inputs.y].forEach(function(inputEl) {
      var value = inputEl.value;
      log('[LPO-RECALC] Trigger input-Event auf', inputEl.name, 'mit Wert:', value);
      inputEl.value = value;
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  // Guard, damit wir nicht 20x direkt hintereinander recalc auslösen
  var recalcScheduled = false;
  function scheduleRecalc(source) {
    if (recalcScheduled) {
      log('[LPO-RECALC] Recalc bereits geplant, skip (' + source + ')');
      return;
    }
    recalcScheduled = true;
    log('[LPO-RECALC] Recalc geplant durch', source);
    setTimeout(function() {
      triggerLpoRecalcFromFormat();
      recalcScheduled = false;
    }, 100);
  }

  function initCartEventsHook() {
    document.addEventListener('cart:change', function(event) {
      log('[LPO-RECALC] cart:change empfangen.', event.detail || null);
      scheduleRecalc('cart:change');
    });

    // Optional: auch beim Hinzufügen eines Produkts triggern
    document.addEventListener('variant:add', function(event) {
      log('[LPO-RECALC] variant:add empfangen.', event.detail || null);
      scheduleRecalc('variant:add');
    });

    log('[LPO-RECALC] cart:change / variant:add Hooks initialisiert.');
  }

  function init() {
    if (typeof document === 'undefined') return;
    log('[LPO-RECALC] Initialisierung gestartet.');
    initCartEventsHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function disableStaffelpreiseRadios() {
    var inputs = document.querySelectorAll(
      '.cl-po--option[data-option="Staffelpreise"] .cl-po--input'
    );

    if (!inputs.length) return;

    inputs.forEach(function(input) {
      // Nur einmal „entwaffnen“
      if (input.__ddfDisabled) return;
      input.__ddfDisabled = true;

      // Fokus & ARIA
      input.setAttribute('tabindex', '-1');
      input.setAttribute('aria-disabled', 'true');

      // Alle Eventtypen killen, die typischerweise Auswahl ändern
      ['click', 'mousedown', 'mouseup', 'keydown', 'keyup', 'change'].forEach(function(eventName) {
        input.addEventListener(eventName, function(e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
      });
    });
  }

  // Direkt versuchen (falls LPO schon gerendert ist)
  disableStaffelpreiseRadios();

  // Alle 500ms erneut prüfen, damit auch neu gerenderte Inputs erwischt werden
  var intervalId = setInterval(disableStaffelpreiseRadios, 500);

  // Optional: nach 30 Sekunden das Intervall beenden
  setTimeout(function() {
    clearInterval(intervalId);
  }, 30000);
})();
